import {useEffect, useRef} from "react";
import TU from '@oscloudlab/thinkup'


const Thinkup = ({ linkToken, customCopy,handleCollapse }) => {
  const module = "代码执行";
  const agent = 'app-hei0wHLZXRbVa1lsEaZyfou4'
  const cards =
    [
      {title: "生成代码", content: "根据要求生成代码。", value: "请根据需求生成代码, 要求代码可以直接运行, 没有单元测试等", icon: "code"},
      {title: "代码分析", content: "逐行分析代码，找出其中的问题和建议。"},
      {title: "代码优化", content: "优化代码，提高代码质量。"},
      {title: "代码补全", content: "根据已有代码，补全缺失的部分。"},
      {title: "单元测试", content: "根据已有代码，生成单元测试代码。"},
      {title: "性能分析", content: "分析代码性能和优化空间"},
      {title: "时间复杂度", content: "分析代码时间复杂度"},
      {title: "空间复杂度", content: "分析代码空间复杂度"},
    ]

  const containerRef = useRef(null);

  useEffect(() => {
    console.log("thinkup init")
    const targetContainer = containerRef.current;
    //console.log(customCopy)
    TU.init({baseUrl: `${process.env.REACT_APP_THINKUP_URL}${linkToken?'?token='+linkToken:''}`,
      targetContainer,
      agent,
      module,
      cards,
      customStyle: {
        borderRadius: '8px',
        border: '1px solid #e7e9e8',
        width: "calc(100% - 2px)",
        height: "calc(100% - 2px)"
      },
      customCopy,
      handleCollapse
    });
  }, []);
  return <div ref={containerRef} style={{width: "100%", height: "100%"}}></div>;
};
export default Thinkup;
